import React from "react";
import { Outlet } from "react-router-dom";

import WebsiteNavbar from "./WebsiteNavbar";
import WebsiteFooter from "./WebsiteFooter";

import "../../styles/website.css";


const WebsiteLayout = () => {

  return (
    <div className="website-layout">

      <WebsiteNavbar />

      <main className="website-main">
        <Outlet />
      </main>

      <WebsiteFooter />

    </div>
  );

};


export default WebsiteLayout;